import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

export default {}


// WEBPACK FOOTER //
// ./src/store/index.js